<div class="chat-post-container">
  <div
    class="bg-white p-3 rounded-10 custom-shadow mb-2"
    *ngFor="let chat of chatData"
  >
    <div class="user-chat-section ps-md-3 ps-lg-4">
      <div class="row">
        <div class="col-auto pe-0 pe-md-3">
          <div class="chat-blog-user-img">
            <a
              [routerLink]="[
                '/',
                { name: chat.username, id: chat.user_id } | UserSlug,
                'profile',
                'statistics'
              ]"
            >
              <img
                [src]="chat.avatar"
                [alt]="chat.username"
                class="img-fluid shadow-sm"
              />
            </a>
          </div>
        </div>
        <div class="col">
          <div class="chat-blog-user-details">
            <ul class="list-inline mb-2">
              <li class="list-inline-item">
                <a
                  [routerLink]="[
                    '/',
                    { name: chat.username, id: chat.user_id } | UserSlug,
                    'profile',
                    'statistics'
                  ]"
                >
                  <span class="user-name">{{ chat.username }}</span></a
                >
              </li>
              <li class="list-inline-item">
                <span class="winning-amount"
                  >{{ chat.sport }} Winnings:
                  {{ chat.sport_winnings || 0 | CustomCurrency }}</span
                >
                <span class="winning-amount" *ngIf="chat.game"
                  ><strong>Game:</strong> {{ chat.game }}</span
                >
              </li>
            </ul>
            <a [routerLink]="['/','chat','latest',chat.id]">
              <p
                class="user-comment-para mb-2"
                [innerHtml]="(_common.isBrowser ? chat.message?.replaceAll('\n', '<br>') : chat.message) || ''"
              ></p>
            </a>
            <ul class="list-inline mb-0 social-media-view-area">
              <li class="list-inline-item">
                <app-chat-count
                  type="likes"
                  [count]="chat.like_arr"
                  [userId]="(_user.authUser | async)?.id?.toString()"
                  (likeUnlike)="likeUnlike(chat)"
                ></app-chat-count>
              </li>
              <li class="list-inline-item" *ngIf="!replies">
                <app-chat-count
                  type="comments"
                  [count]="chat.repliesCount || 0"
                  (replies)="getReplies(chat)"
                ></app-chat-count>
              </li>
              <li class="list-inline-item ms-md-3">
                <span class="posting-time-status">{{ _common.isBrowser ? (chat.created_at | duration | async) : (chat.created_at | durationServer) }}</span>
              </li>
            </ul>
          </div>
          <div class="user-chat-section">
            <app-chat-box
              type="reply"
              [username]="chat.username"
              *ngIf="chat.showReply"
              (reply)="replyMessage($event, chat)"
            ></app-chat-box>
            <div *ngIf="chat.loading" class="text-center mt-4">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            </div>
            <!-- <app-replies
              *ngIf="chat.showReply"
              [replies]="chat.replies"
              [sport]="selectedSport"
              [userId]="(_user.authUser | async)?.id?.toString()"
              (like)="likeUnlike($event)"
            ></app-replies> -->
            <app-chat-data *ngIf="chat.showReply" [chatData]="chat.replies || []" [room]="selectedSport" [replies]="true"></app-chat-data>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="text-center my-4" *ngIf="paging">
    <button
      #button
      class="btn btn-theme"
      type="button"
      (click)="loadMoreData(button)"
    >
      Load More
    </button>
  </div>
</div>
